import { useCallback, useState } from 'react'
import { flatten } from 'shared/util'
import { Button } from '@mui/material'
import { TrushIcon } from 'shared/icons'

import { FormDialog } from 'components/dialog/form'
import { ConfirmDialog } from 'components/dialog/confirm'

import { useEditGroup, useDeleteGroup, GroupResult } from 'interface/user/group'
import { GroupForm, useGroupForm } from '../form'

type EditGroupDialogProps = {
  group: GroupResult
  onEditGroup: (group: GroupResult) => void
  onDeleteGroup: (groupId: number) => void
  onClose: () => void
}
export const EditGroupDialog = ({
  group,
  onEditGroup,
  onDeleteGroup,
  onClose
}: EditGroupDialogProps) => {
	const [modal, setModal] = useState<"deleteGroup" | null>(null)

  const onEditted = useCallback(
    (result: GroupResult) => {
      onEditGroup(result)
      onClose()
    },
    [onClose, onEditGroup]
  )
  const [editGroupState, editGroup] = useEditGroup(group.groupId, { onEditted })
  const form = useGroupForm({ group, onSubmit: editGroup })

  const onDeleted = useCallback(
    (groupId: number) => {
      onDeleteGroup(groupId)
      onClose()
    },
    [onClose, onDeleteGroup]
  )
  const [deleteGroupState, deleteGroup] = useDeleteGroup({ onDeleted })

  return (
    <FormDialog
      open
      fullWidth
      maxWidth="sm"
      title="グループ情報を編集"
      isLoading={editGroupState.posting}
      error={flatten([
        editGroupState.error,
        deleteGroupState.error
      ])}
      body={<GroupForm {...form}/>}
      leftAction={
        <Button
          variant="contained"
          color="error"
          size="large"
          startIcon={<TrushIcon/>}
          onClick={() => setModal("deleteGroup")}
        >
          削除
        </Button>
      }
      isValid={form.formState.isValid}
      submitLabel="保存"
      onSubmit={form.submit}
      onClose={onClose}
    >
      {(modal === 'deleteGroup') ? (
        <ConfirmDialog
          isLoading={deleteGroupState.posting}
          message={`${group.groupName} を削除します。よろしいですか？`}
          ok={{
            label: 'はい',
            onClick: () => deleteGroup(group?.groupId)
          }}
          cancel={{
            label: 'いいえ',
            onClick: () => setModal(null)
          }}
        />
      ) : (
        <></>
      )}
    </FormDialog>
  )
}
